import React from 'react';
import { createSvgIcon } from '../../utils/createSvgIcon';

export const MetalIcon = createSvgIcon(
  <svg width="69" height="80" viewBox="0 0 69 80" xmlns="http://www.w3.org/2000/svg">
    <g fill="#333333">
      <path d="M0 20V60L34.5 80L69 60V20L34.5 0L0 20Z" fill="#FDB928" />
      <path d="M62.9791 41.3131V56.3283L50.0272 63.8384L37.0752 56.3283V41.3131L50.0272 33.803L62.9791 41.3131Z" />
      <path d="M31.9246 41.3131V56.3283L18.9726 63.8384L6.01562 56.3283V41.3131L18.9726 33.803L31.9246 41.3131Z" />
      <path d="M47.452 14.5556V29.5758L34.5001 37.0808L21.5481 29.5758V14.5556L34.5001 7.04546L47.452 14.5556Z" />
    </g>
  </svg>,
  'Metal'
);
